// extracted by css-extract-rspack-plugin
export default {"flags-wrapper":"FaIESV","flagsWrapper":"FaIESV"};